import IconNameEnum from "constants/IconNameEnum";
import IAction from "models/IAction";
import IStore from "models/IStore";
import moment from "moment";
import React from "react";
import { Form, Row, Col, ProgressBar } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import LookUpAction from "stores/lookup/LookUpAction";
import AdministrativeCategoryModel from "stores/lookup/models/AdminisrativeCategoryModel";
import CanaliModel from "stores/lookup/models/CanaliModel";
import AgentiProvvModel from "stores/lookup/models/AgentiProvvModel";
import DurataModel from "stores/lookup/models/DurataModel";
import LookupManagementModel from "stores/lookup/models/LookupManagementModel";
import SegmentiModel from "stores/lookup/models/SegmentiModel";
import TipoProdottoModel from "stores/lookup/models/TipoProdottoModel";
import TipoRichiestaModel from "stores/lookup/models/TipoRichiestaModel";
import CercaAction from "stores/ricerca/CercaAction";
import { ISearchPreventiviRequest } from "stores/ricerca/CercaEffects";
import CercaPreventiviFormModel from "stores/ricerca/models/CercaPreventiviFormModel";
import FormatUtility from "utilities/FormatUtility";
import ValidationUtility, { ValidationContainer } from "utilities/ValidationUtility";
import BaseModal from "views/components/base-content/BaseModal";
import BasePageCard from "views/components/base-content/BasePageCard";
import BaseAutoComplete from "views/components/base-form/BaseAutoComplete";
import BaseButton from "views/components/base-form/BaseButton";
import BaseDate from "views/components/base-form/BaseDate";
import BaseIcon from "views/components/base-form/BaseIcon";
import BaseInput from "views/components/base-form/BaseInput";
import CercaPreventiviTabella from "./CercaPreventiviTabella";
import LoadingIndicator from "../components/loading-indicator/LoadingIndicator";
import LookUpModel from "../../stores/lookup/models/LookUpModel";
import FunctionEnum from "../../constants/FunctionEnum";

interface IProps {}

interface IState {
    readonly isDownloading: boolean;
    readonly progressDownload: number;
    readonly PaginationFirstElem: number;
    readonly PaginationLastElem: number;
    readonly validationContainer: ValidationContainer<CercaPreventiviFormModel>;
}

interface IRouteParams {}

interface IStateToProps {
    readonly isRequesting: boolean;
    readonly isUtenteDirezione: boolean;
    readonly administrativeCategory: AdministrativeCategoryModel[]; //replace with agente
    readonly tipoRichiesta: TipoRichiestaModel[];
    readonly canali: CanaliModel[];
    readonly agentiProvv: AgentiProvvModel[];
    readonly segmenti: SegmentiModel[];
    readonly durata: DurataModel[];
    readonly isIE: boolean /*  */;
    readonly isSafari: boolean;
    readonly atc: LookupManagementModel[];
    readonly formModel: CercaPreventiviFormModel;
    readonly productTypes: TipoProdottoModel[];
    readonly lkStatoPrev: LookUpModel[];
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: false,
    isUtenteDirezione: state.utente.profilo.tipoCdc == "D",
    administrativeCategory: state.lookup.administrativeCategory,
    durata: state.lookup.durata,
    atc: state.lookup.management,
    tipoRichiesta: state.lookup.tipiRichieste,
    isIE: state.config.isIE,
    isSafari: state.config.isSafari,
    canali: state.lookup.canali,
    agentiProvv: state.lookup.agentiProvv,
    segmenti: state.lookup.segmenti,
    formModel: state.cerca.cercaPreventiviForm,
    productTypes: state.lookup.productTypes,
    lkStatoPrev: state.lookup.statoPrev,
});

export class CercaPreventivo extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            progressDownload: 0,
            isDownloading: false,
            PaginationFirstElem: 0,
            PaginationLastElem: 0,
            validationContainer: ValidationUtility.setValidationContainer<CercaPreventiviFormModel>(
                new CercaPreventiviFormModel({})
            ),
        } as IState;
    }

    private hasUnmounted = false;
    private validationSchema = ValidationUtility.getSchemaCercaPreventivo();
    private formRef: React.RefObject<HTMLFormElement> = React.createRef<HTMLFormElement>();
    private downloadFileRef: React.RefObject<HTMLAnchorElement> = React.createRef<HTMLAnchorElement>();

    public componentWillUnmount() {
        this.hasUnmounted = true;
        this.props.dispatch(CercaAction.resetCercaPreventivi());
    }

    componentDidMount() {
        let { formModel, isUtenteDirezione } = this.props;
        this.props.dispatch(LookUpAction.administrativeCategoryGet());
        this.props.dispatch(LookUpAction.resetCanali());
        this.props.dispatch(LookUpAction.canaliGet(Number(formModel.agente), isUtenteDirezione));
        this.props.dispatch(LookUpAction.agentiProvvGet());
        this.props.dispatch(LookUpAction.productTypesGet());
        this.props.dispatch(LookUpAction.StatoPrevGet());
    }

    handleCerca = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.onSubmitHandler(event);
    };

    private onChangeHandler = async (name: string, value: string | number | boolean | Date) => {
        const { tipoRichiesta, formModel, atc } = this.props;

        let formValues = new CercaPreventiviFormModel(formModel);

        formValues = FormatUtility.updateNestedPropertyValue<CercaPreventiviFormModel>(formValues, name, value);

        if (name === "atc") {
            const selectedAtc = atc.find((item: LookupManagementModel) => item.key === value);
            const cliente = selectedAtc?.idAdmCategory?.toString() || "";

            formValues = FormatUtility.updateNestedPropertyValue<CercaPreventiviFormModel>(
                formValues,
                "tipoCliente",
                cliente
            );
        }

        if (name === "tipoCliente" && formValues.canale && formValues.tipoRichiesta) {
            this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(formValues.tipoRichiesta),
                    Number(value),
                    Number(formValues.canale),
                    Number(
                        ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                            ? formModel.agente.toString().split("|")[0]
                            : formModel.agente
                    )
                )
            );
        }

        if (name === "canale" && formValues.tipoCliente && formValues.tipoRichiesta) {
            this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(formValues.tipoRichiesta),
                    Number(formValues.tipoCliente),
                    Number(value),
                    Number(
                        ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                            ? formModel.agente.toString().split("|")[0]
                            : formModel.agente
                    )
                )
            );
        }

        if (name === "tipoRichiesta" && formValues.tipoCliente && formValues.canale) {
            this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(value),
                    Number(formValues.tipoCliente),
                    Number(value),
                    Number(
                        ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                            ? formModel.agente.toString().split("|")[0]
                            : formModel.agente
                    )
                )
            );
        }

        formValues = FormatUtility.updateNestedPropertyValue<CercaPreventiviFormModel>(formValues, name, value);

        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.setCercaPreventivoForm(formValues));
        }
    };

    private onBlurHandler = async (name: string) => {
        let validationContainer = await ValidationUtility.validateSchema<CercaPreventiviFormModel>(
            this.validationSchema,
            this.state.validationContainer,
            this.props.formModel,
            name,
            undefined
        );

        if (this.hasUnmounted === false) {
            this.setState({
                validationContainer: validationContainer,
            });
        }
    };

    private onSubmitHandler = async (
        event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        event.preventDefault();
        let validationContainer = await ValidationUtility.validateSchema<CercaPreventiviFormModel>(
            this.validationSchema,
            this.state.validationContainer,
            this.props.formModel,
            undefined,
            undefined
        );
        if (this.hasUnmounted === false) {
            this.setState({
                validationContainer: validationContainer,
            });
        }

        if (ValidationUtility.checkValidity(validationContainer) === true) {
            this.submit();
        } else {
            if (this.hasUnmounted === false) {
                this.setState({}, () => {
                    ValidationUtility.scrollToFirstError<CercaPreventiviFormModel>(
                        validationContainer,
                        "cercaPreventivo."
                    );
                });
            }
        }
    };

    private submit = async () => {
        let data = new CercaPreventiviFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString() : "";
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }
        const request: ISearchPreventiviRequest = {
            pageNumber: 1,
            pageSize: 20,
            sortParam: data.colName!,
            sortAsc: data.direction === "A" ? true : false,
            idEstimateRequest: data.numPreventivo ? data.numPreventivo : undefined,
            idPractice: data.numPratica ? data.numPreventivo : undefined,
            creationDateFrom: dataCreazioneDa ? dataCreazioneDa : undefined,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            simulationName: data.denominazione ? data.denominazione : undefined,
            idSimulation: data.numSimulazione ? data.numSimulazione : undefined,
            idAgent: data.agente ? data.agente : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            // idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            installment: data.rata ? parseFloat(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo.replace(",", ".").replace(".", "")) : undefined,
            idProductType: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            firstName: data.firstName ? data.firstName : undefined,
            lastName: data.lastName ? data.lastName : undefined,
            idStatoPrev: data.idStatoPrev,
        };
        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.searchEstimates(request));
        }
    };

    onInputChangeHandlerAutocomplete = async (name: string, value: string) => {
        value?.length > 2 && (await this.props.dispatch(LookUpAction.lookupManagementGet(value)));
    };

    private requestDownloadDocumento = async (
        request: ISearchPreventiviRequest,
        progressHandler: (progress: number) => void
    ): Promise<Blob> => {
        return await this.props
            .dispatch(CercaAction.preventiviExportExcel(request, progressHandler))
            .then((response: Blob) => response);
    };

    private downloadDocumento = () => {
        let data = new CercaPreventiviFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchPreventiviRequest = {
            pageNumber: 1,
            pageSize: 20,
            sortParam: data.colName!,
            sortAsc: data.direction === "A" ? true : false,
            //idEstimate: data.numPreventivo ? data.numPreventivo : undefined,
            idEstimateRequest: data.numPreventivo ? data.numPreventivo : undefined,
            idPractice: data.numPratica ? data.numPreventivo : undefined,
            creationDateFrom: dataCreazioneDa ? dataCreazioneDa : undefined,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            simulationName: data.denominazione ? data.denominazione : undefined,
            idSimulation: data.numSimulazione ? data.numSimulazione : undefined,
            idAgent: data.agente ? data.agente : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            installment: data.rata ? parseFloat(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
            idProductType: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            firstName: data.firstName ? data.firstName : undefined,
            lastName: data.lastName ? data.lastName : undefined,
        };

        if (this.hasUnmounted === false) {
            this.setState({
                isDownloading: true,
            });
        }
        const updateProgress = (progress: number) => {
            if (this.hasUnmounted === false) {
                this.setState({
                    progressDownload: progress,
                });
            }
        };

        this.requestDownloadDocumento(request, updateProgress).then((response: Blob) => {
            if (response && response instanceof Blob && this.downloadFileRef.current) {
                this.downloadFileRef.current.href = window.URL.createObjectURL(response);
                let ext = ".xlsx";
                this.downloadFileRef.current.download = "Elenco prventivi" + ext;
                this.downloadFileRef.current.click();
            }
            if (this.hasUnmounted === false) {
                this.setState({
                    isDownloading: false,
                    progressDownload: 0,
                });
            }
        });
    };

    public render(): JSX.Element {
        const {
            tipoRichiesta,
            administrativeCategory,
            canali,
            agentiProvv,
            segmenti,
            durata,
            atc,
            formModel,
            productTypes,
            lkStatoPrev,
        } = this.props;

        const { isDownloading, progressDownload, validationContainer } = this.state;

        //const agents: any = [];

        const disabled = formModel.numPreventivo !== "";

        return (
            <>
                {this.props.isRequesting ? (
                    <LoadingIndicator className="mb-3" isActive={true} />
                ) : (
                    <Form className="h-100" id="ricerca" ref={this.formRef} noValidate onSubmit={this.onSubmitHandler}>
                        <BasePageCard
                            isIE={false}
                            isSafari={false}
                            isRequesting={false}
                            headerIcon={IconNameEnum.RicercaGrigio}
                            headerTitle="Cerca preventivo"
                        >
                            <Row className="align-items-center mb-3">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.numPreventivo"
                                        floatingLabel={true}
                                        placeholder="---"
                                        type="text"
                                        name="numPreventivo"
                                        value={formModel.numPreventivo}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        customFormat="numbers"
                                        formatOnDigit={true}
                                        label="N&#176; preventivo"
                                    />
                                </Col>

                                <Col className="align-items-center" sm={12} md={4} xl={4}>
                                    <BaseDate
                                        controlId="cercaPreventivo.dataCreazioneDa"
                                        floatingLabel={true}
                                        placeholder="gg/mm/aaaa"
                                        name="dataCreazioneDa"
                                        value={formModel.dataCreazioneDa}
                                        showCalendar={true}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        onBlurHandler={this.onBlurHandler}
                                        isInvalid={validationContainer.dataCreazioneDa.invalid}
                                        error={validationContainer.dataCreazioneDa.message}
                                        disabled={disabled}
                                        label="Data creazione da"
                                    />
                                </Col>

                                <Col className="align-items-center" sm={12} md={4} xl={4}>
                                    <BaseDate
                                        controlId="cercaPreventivo.dataCreazioneA"
                                        floatingLabel={true}
                                        placeholder="gg/mm/aaaa"
                                        name="dataCreazioneA"
                                        value={formModel.dataCreazioneA}
                                        showCalendar={true}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        onBlurHandler={this.onBlurHandler}
                                        isInvalid={validationContainer.dataCreazioneA.invalid}
                                        error={validationContainer.dataCreazioneA.message}
                                        max={moment().toDate()}
                                        disabled={disabled}
                                        label="Data creazione a"
                                    />
                                </Col>

                                {/* <Col sm={12} md={3} xl={2} className="pl-6">
                            <span className="font-weight-bold">
                                N<span>&#176;</span> pratica:
                            </span>
                        </Col>

                        <Col sm={12} md={3} xl={2}>
                            <BaseInput
                                controlId="cercaPreventivo.numPratica"
                                floatingLabel={true}
                                placeholder="---"
                                type="text"
                                name="numPratica"
                                value={formModel.numPratica}
                                required={false}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                            />
                        </Col> */}
                            </Row>

                            <Row className="align-items-center mb-3 ">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.numSimulazione"
                                        floatingLabel={true}
                                        placeholder="---"
                                        type="text"
                                        name="numSimulazione"
                                        value={formModel.numSimulazione}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        disabled={disabled}
                                        label="N&#176; simulazione"
                                        customFormat="numbers"
                                        formatOnDigit={true}
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.denominazione"
                                        floatingLabel={true}
                                        placeholder="---"
                                        type="text"
                                        name="denominazione"
                                        value={formModel.denominazione}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        disabled={disabled}
                                        label="Denominazione simulazione"
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        controlId="cercaPreventivo.idStatoPrev"
                                        value={formModel.idStatoPrev?.toString() || ""}
                                        onChangeHandler={this.onChangeHandler}
                                        placeholder="---"
                                        isInvalid={false}
                                        error={""}
                                        floatingLabel={true}
                                        name="idStatoPrev"
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromLookup(lkStatoPrev)}
                                        disabled={disabled}
                                        label="Stato preventivo"
                                    />
                                </Col>
                            </Row>

                            <Row className="align-items-center mb-3 ">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        sortOptions={true}
                                        controlId="cercaPreventivo.agente"
                                        value={formModel.agente}
                                        onChangeHandler={this.onChangeHandler}
                                        placeholder="Selezionare..."
                                        isInvalid={false}
                                        error={""}
                                        floatingLabel={true}
                                        name="agente"
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromAgentiProvvLookup(agentiProvv)}
                                        disabled={disabled}
                                        label="Agente"
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        sortOptions={true}
                                        controlId="cercaPreventivo.canale"
                                        name="canale"
                                        floatingLabel={true}
                                        placeholder="Selezionare..."
                                        value={formModel.canale}
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromLookup(canali)}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        disabled={disabled}
                                        label="Canale"
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        sortOptions={true}
                                        controlId="cercaPreventivo.segmento"
                                        name="segmento"
                                        floatingLabel={true}
                                        placeholder="Selezionare..."
                                        value={formModel.segmento}
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromLookup(segmenti)}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        disabled={disabled}
                                        label="Segmento"
                                    />
                                </Col>
                            </Row>
                            <Row className="align-items-center mb-3">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        sortOptions={true}
                                        controlId="cercaPreventivo.tipoRichiesta"
                                        value={formModel.tipoRichiesta}
                                        onChangeHandler={this.onChangeHandler}
                                        placeholder="Selezionare..."
                                        isInvalid={false}
                                        error={""}
                                        floatingLabel={true}
                                        name="tipoRichiesta"
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromLookup(tipoRichiesta)}
                                        disabled={disabled}
                                        label="Tipo richiesta"
                                    />
                                </Col>
                                {!ValidationUtility.verificaFn(FunctionEnum.FN_BPP) && (
                                    <Col sm={12} md={4} xl={4}>
                                        <BaseAutoComplete
                                            sortOptions={true}
                                            controlId="cercaPreventivo.tipoProdotto"
                                            value={formModel.tipoProdotto}
                                            onChangeHandler={this.onChangeHandler}
                                            placeholder="Selezionare.."
                                            isInvalid={false}
                                            error={""}
                                            floatingLabel={true}
                                            name="tipoProdotto"
                                            required={false}
                                            options={FormatUtility.getOptionValuesFromLookup(productTypes)}
                                            disabled={disabled}
                                            label="Tipo prodotto"
                                        />
                                    </Col>
                                )}
                            </Row>
                            <Row className="align-items-center mb-3">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        controlId="cercaPreventivo.atc"
                                        name="atc"
                                        floatingLabel={true}
                                        placeholder="Ricercare..."
                                        value={formModel.atc}
                                        required={false}
                                        searchInside={true}
                                        options={FormatUtility.getOptionValuesFromLookup(atc)}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        onInputChangeHandler={this.onInputChangeHandlerAutocomplete}
                                        disabled={disabled}
                                        label="ATC"
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        sortOptions={true}
                                        controlId="cercaPreventivo.tipoCliente"
                                        value={formModel.tipoCliente}
                                        onChangeHandler={this.onChangeHandler}
                                        placeholder="Selezionare..."
                                        isInvalid={false}
                                        error={""}
                                        floatingLabel={true}
                                        name="tipoCliente"
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromLookup(administrativeCategory)}
                                        disabled={disabled}
                                        label="Tipologia Cliente"
                                    />
                                </Col>
                            </Row>
                            <Row className="align-items-center mb-3">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.firstName"
                                        floatingLabel={true}
                                        placeholder="---"
                                        type="text"
                                        name="firstName"
                                        value={formModel.firstName}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        disabled={disabled}
                                        label="Nome"
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.lastName"
                                        floatingLabel={true}
                                        placeholder="---"
                                        type="text"
                                        name="lastName"
                                        value={formModel.lastName}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        disabled={disabled}
                                        label="Cognome"
                                    />
                                </Col>
                            </Row>
                            <Row className="align-items-center mb-3 cerca-row pt-3 pb-3">
                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.rata"
                                        value={formModel.rata}
                                        onChangeHandler={this.onChangeHandler}
                                        placeholder="---"
                                        isInvalid={false}
                                        error={""}
                                        floatingLabel={true}
                                        type="text"
                                        name="rata"
                                        required={false}
                                        step={0.01}
                                        customFormat="numberWithSeparators"
                                        formatOnDigit={true}
                                        append={<BaseIcon icon={IconNameEnum.Euro} />}
                                        disabled={disabled}
                                        label="Rata"
                                    />
                                </Col>
                                <Col sm={12} md={4} xl={4}>
                                    <BaseAutoComplete
                                        controlId="cercaPreventivo.durata"
                                        value={formModel.durata?.toString() || ""}
                                        onChangeHandler={this.onChangeHandler}
                                        placeholder="---"
                                        isInvalid={false}
                                        error={""}
                                        floatingLabel={true}
                                        name="durata"
                                        required={false}
                                        options={FormatUtility.getOptionValuesFromLookup(durata)}
                                        disabled={disabled}
                                        label="Durata (mesi)"
                                    />
                                </Col>

                                <Col sm={12} md={4} xl={4}>
                                    <BaseInput
                                        controlId="cercaPreventivo.importo"
                                        floatingLabel={true}
                                        placeholder="---"
                                        append={<BaseIcon icon={IconNameEnum.Euro} />}
                                        type="text"
                                        name="importo"
                                        value={formModel.importo}
                                        required={false}
                                        onChangeHandler={this.onChangeHandler}
                                        isInvalid={false}
                                        error={""}
                                        step={0.01}
                                        customFormat="numberWithSeparators"
                                        formatOnDigit={true}
                                        disabled={disabled}
                                        label="Importo"
                                    />
                                </Col>
                            </Row>
                            <Row className="p-2 align-items-center">
                                {disabled && (
                                    <Col sm={12} md={6}>
                                        <span className="font-weight-bold">
                                            N<span>&#176;</span> preventivo valorizzato, gli altri filtri non verranno
                                            considerati.
                                        </span>
                                    </Col>
                                )}
                                <Col sm={12} md={disabled ? 6 : 12} className="text-right">
                                    <BaseButton
                                        label="Cerca"
                                        icon={IconNameEnum.Cerca}
                                        onClickHandler={this.handleCerca}
                                        type="button"
                                        color="blue"
                                    />
                                </Col>
                            </Row>
                            <hr />
                            <CercaPreventiviTabella onExportSimulazione={this.downloadDocumento} />
                        </BasePageCard>
                        <a ref={this.downloadFileRef} hidden className="d-none" href="" download=""></a>
                        <BaseModal
                            show={isDownloading}
                            closeOnOutClick={false}
                            centered={true}
                            body={
                                <Row>
                                    <Col className="text-center">
                                        <h5 className="text-ecq-blue">Attendere</h5>
                                        <Form.Label>Download in corso</Form.Label>
                                        <ProgressBar
                                            animated
                                            min={0}
                                            max={100}
                                            now={progressDownload}
                                            label={progressDownload + "%"}
                                        />
                                    </Col>
                                </Row>
                            }
                        />
                    </Form>
                )}
            </>
        );
    }
}

export { CercaPreventivo as Unconnected };
export default connect(mapStateToProps)(CercaPreventivo);
